// Worker の /api/identify を呼び出して作品を識別する
// 返り値の例:
//   { status: 'identified', title, artist, year, medium, confidence, summary_hint, raw }
//   { status: 'candidates', candidates: [{title, artist, year, reason}, ...] }
//   { status: 'unknown', visualDescription: '...' }

const API_BASE = import.meta.env.VITE_API_BASE || '';

export async function identify(imageBlob, hint = {}) {
  const form = new FormData();
  form.append('image', imageBlob, 'capture.jpg');
  if (hint.museumId) form.append('museumId', hint.museumId);
  if (hint.museum) form.append('museum', hint.museum);
  if (hint.previousTitle) form.append('previousTitle', hint.previousTitle);

  const res = await fetch(`${API_BASE}/api/identify`, {
    method: 'POST',
    body: form,
  });

  if (!res.ok) {
    const message = await safeErrorMessage(res);
    throw new Error(message);
  }
  return await res.json();
}

// テキスト入力（タイトル・作者）から作品を識別
export async function identifyByText({ title, artist, year, museumId }) {
  const res = await fetch(`${API_BASE}/api/identify-by-text`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ title, artist, year, museumId }),
  });

  if (!res.ok) {
    const message = await safeErrorMessage(res);
    throw new Error(message);
  }
  return await res.json();
}

async function safeErrorMessage(res) {
  try {
    const data = await res.json();
    return data?.error || `識別に失敗しました (${res.status})`;
  } catch {
    return `識別に失敗しました (${res.status})`;
  }
}
